
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import q_ajax_3 from "app/utils/q_ajax/q_ajax_3"
import Modal from "app/modal/show-modal"
import Auth_action from "app/authentication/action"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import Problem_Box from "../box/index"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--listings--problems--reports--new-report--button"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = u(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    const $remote_link_elements = $el.find(".cell--listings--problems--reports--new-report--button__anchor")

    $remote_link_elements.on("click", (e) => {
      const $link = u(e.currentTarget as HTMLElement)
      const url = $link.attr("href")

      q_ajax_3(
        {
          url:      url,
          type:     "GET",
          dataType: "html",
        },
        {
          error_tracking_options: {
            endpoint_identifier: "app/assets/javascripts/concepts/listings/problems/reports/new_report/button/index#init",
          },
        },
      )
      .then(({data}: {data: string}) => {
        Modal.showModalWithContent(data)
        Problem_Box.init()
      })
      .catch(({response}) => {
        if (response.status === 401) {
          Auth_action.showSignInModal().done()
        }
      })

      e.preventDefault()
    })

  })
}

export default {init}
